/**
 * Opens the store-availability drawer (#Pickup-Availability) when the
 * "View availability at our stores" link is clicked. The drawer content is fully
 * rendered server-side (every size shown per store), so no further interaction is
 * needed here. Opening goes through the theme's global OverlayManager so that the
 * shared <side-panel-close> element and the .click-capture overlay can close it again.
 *
 * A delegated listener is used so the trigger keeps working after the buy-buttons
 * area is re-rendered on variant change (product.js -> renderProductInfo).
 */
if (!window.storeAvailabilityInit) {
  window.storeAvailabilityInit = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.store-availability__info-button');
    if (!trigger) return;

    const panel = document.getElementById('Pickup-Availability');
    if (!panel) return;

    event.preventDefault();
    // OverlayManager owns the .active class, the inert attribute, focus trapping
    // and the open-cc body class, and <side-panel-close> closes via its stack.
    OverlayManager.open(panel);
  });
}
